export const getDecorationTypeMappedList = (typesDtoList) => {
    const mappedList = typesDtoList.map(dtoItem => {
        var title;
        if (dtoItem.thematicParentLv1Id) {
            if (dtoItem.thematicParentLv2Id) {
                var typeThematicLv1 = typesDtoList.find(item => item.id === dtoItem.thematicParentLv1Id)
                var typeThematicLv2 = typesDtoList.find(item => item.id === dtoItem.thematicParentLv2Id)
                title = `${typeThematicLv1.title} - ${typeThematicLv2.title} - ${dtoItem.title}`
            } else {
                var typeThematicLv1 = typesDtoList.find(item => item.id === dtoItem.thematicParentLv1Id)
                title = `${typeThematicLv1.title} - ${dtoItem.title}`
            }
        }
        else if (dtoItem.parentLv1Id) {
            var typeLv1 = typesDtoList.find(item => item.id === dtoItem.parentLv1Id)
            title = `${typeLv1.title} - ${dtoItem.title}`
        }
        else {
            title = dtoItem.title
        }
        return { ...dtoItem, title: `${title}` };
    })
    return mappedList;
}